<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Other info</mat-card-title>
    <button *ngIf="edit"
            mat-icon-button
            routerLink="/customer/{{data.id}}"
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>cloud</mat-icon>
        <span matListItemTitle>
          <a class="default-link"
             [href]="data.uniqueId | salesforceUrl"
             target="_blank"
             rel="noopener">{{data.uniqueId}}
          </a>
        </span>
        <span matListItemLine>Salesforce ID</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>phonelink_lock</mat-icon>
        <span matListItemTitle>{{data?.accountType}}</span>
        <span matListItemLine>Account type</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>account_circle</mat-icon>
        <span matListItemTitle>{{data.status | enumValueLabel}}</span>
        <span matListItemLine>Customer status</span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
